var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// 公共 store 参数存放
import Vue from 'vue';
import Vuex from 'vuex';
import common from './common'; // 公共store
import getters from './getters';
import user from './modules/user';
import permission from './modules/permission';
import app from './modules/app';
import crm from './modules/crm';
Vue.use(Vuex);
// 自动化引入 views/routeName/store/index.ts
var pageList = process.env.PAGE_LIST;
var storeMap = {};
if (pageList && pageList.length) {
    pageList.forEach(function (page) {
        var relativePath = page.relativePath.split('/pages/');
        var currentStoreConfig = require("../views/" + relativePath[0] + "/store/index.ts").default;
        storeMap[relativePath[0]] = currentStoreConfig;
    });
}
var store = new Vuex.Store({
    modules: __assign(__assign({ common: common }, storeMap), { app: app,
        permission: permission,
        crm: crm,
        user: user }),
    mutations: {
        // 重置state
        RESET_MODULE_STATE: function (state) {
            for (var stateItem in state) {
                if (stateItem === 'schedule') {
                    state[stateItem] = {
                        searchParams: {}
                    };
                }
                else if (stateItem !== 'common') {
                    state[stateItem] = {};
                }
            }
        },
    },
    getters: __assign({ menuList: function (state) { return state.user.menuList; }, permissionList: function (state) { return state.user.permissionList; } }, getters),
});
export default store;
